import { size, __spreadValues } from './chunk-JJ6VZ5V7.mjs';
import * as React from 'react';
import styled, { color } from '@xstyled/styled-components';

var SvgComponent = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  __spreadValues({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24px",
    height: "24px",
    fill: "none",
    "aria-hidden": "true",
    viewBox: "0 0 24 24"
  }, props),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "M6.398 7.398 3.75 4.75a1.06 1.06 0 0 1 1.5-1.5l3.227 3.227 1.131 1.131 1.52 1.52L12 10l2 2 .871.871 1.52 1.52 1.919 1.918 2.44 2.441a1.06 1.06 0 0 1-1.5 1.5l-2.877-2.877c-4.92 2.086-11.121.48-14.065-4.819a1.11 1.11 0 0 1 .014-1.1 11.13 11.13 0 0 1 4.076-4.056M8 9a5 5 0 0 0 7 7l-1.438-1.438a3 3 0 0 1-4.124-4.124z",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "currentColor",
      d: "M21.692 12.554a11.2 11.2 0 0 1-2.267 2.871l-2.509-2.509Q17 12.47 17 12a5 5 0 0 0-5.916-4.916l-1.002-1.002c4.342-.739 9.055 1.052 11.596 5.371.2.339.205.758.014 1.101"
    }
  )
);
var SvgVisibleOffFilled = styled(SvgComponent)`
  ${size}
  ${color}
`;
var VisibleOffFilled_default = SvgVisibleOffFilled;

export { VisibleOffFilled_default as default };
